import { h } from 'preact';
import * as BaseComp from 'components/bolt/text/text.js';
import { navigateInternally } from 'utils/bolt';
import { getDynamicData } from 'utils/bolt/dynamicData';
import Store from 'store/store';
// import s from 'components/bolt/text/text.sss';

export default class Text extends BaseComp.default {

	async loadCustomData(file) {
		const dynamicData = await getDynamicData(file);
		if (!dynamicData) {
			return;
		}

		// const imageRoot = this.props.appData?.urls?.roots?.image || '';
		this.text = `
![${dynamicData.hero?.alt}](${dynamicData.hero?.hero})
<div class="body">
	<p class="h1">${dynamicData.title}</p>
	<hr class="divider">

${dynamicData.description}

</div>`;
		this.forceUpdate();
	}

	async componentDidMount(...args) {
		super.componentDidMount?.(...args);
		if (this.props.id === 'inProduction') {
			await this.loadCustomData('production');
		}
	}

	onClick(e) {
		if (Store.get().activePage === 'aboutScroll') {
			Store.emit('CUSTOM_EVENT', {
				category: 'about',
				action: 'contact-click',
				label: e.target.innerHTML
			});
		}

		let internalLink = e.target.closest('a[href^="#$"]');
		if (internalLink) {
			e.preventDefault();
			let page = internalLink.getAttribute('href').slice(2).trim();
			let navOptions = {};
			if (page.includes('/?')) {
				let [pageId, qs] = page.split('/?');
				page = pageId;
				navOptions.queryString = '?' + qs;
			}
			navigateInternally(page, navOptions);
		}
	}
}
